import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { storeUserRole } from 'Actions/userRoles';
import { loadRoles } from 'Actions/user';
import { loadAutocomplete } from 'Actions/journal';
import { ROLES_HAS_JOURNAL, ROLE_REVIEWER } from 'Constants';

import { JournalAutocomplete } from 'Containers/Autocomplete';
import CustomSelect from 'Common/CustomSelect';
import Lightbox from 'Common/Lightbox';
import Button from 'Common/CustomButtons/Button';
import GridContainer from 'Common/Grid/GridContainer.jsx';
import ItemGrid from 'Common/Grid/ItemGrid.jsx';

@connect(
    store => ({
        rolesList: store.userListRoles.data,
        userRolesList: store.userRolesList.data,
    }),
    dispatch => ({
        loadRoles: () => dispatch(loadRoles()),
        storeUserRole: data => dispatch(storeUserRole(data)),
        loadJournalsAutocomplete: filter => dispatch(loadAutocomplete(filter)),
    })
)
export default class UserAddRole extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        rolesList: PropTypes.array.isRequired,
        userRolesList: PropTypes.any.isRequired,
        match: PropTypes.object.isRequired,
        loadRoles: PropTypes.func.isRequired,
        storeUserRole: PropTypes.func.isRequired,
        loadJournalsAutocomplete: PropTypes.func.isRequired,
    };

    state = {
        isOpen: false,
        role: null,
        journal: null,
    };

    /**
     * Init component
     */
    componentDidMount() {
        const { loadRoles } = this.props;
        loadRoles();
    }

    /**
     * Get unused roles
     */
    getRolesList = () => {
        const { rolesList, userRolesList } = this.props;

        const activeRoles = userRolesList.filter(role => ROLES_HAS_JOURNAL.indexOf(role.role.slug) === -1).map(role => {
            return role.role_id;
        });

        return rolesList.filter(role => activeRoles.indexOf(role.id) === -1).map(role => {
            return { label: role.name, value: role.id };
        });
    };

    /**
     * Get filter for journals
     *
     * @returns {{where: {id: {nin}}}}
     */
    getJournalsFilter = () => {
        const { userRolesList } = this.props;
        const { role: roleId } = this.state;

        return {
            where: {
                id: { nin: userRolesList.filter(role => (role.role_id === roleId) && !!role.journal_id).map(role => role.journal_id) },
            },
        };
    };

    /**
     * Get array of id that has journal roles
     */
    getHasJournalRoles() {
        const { rolesList } = this.props;

        return rolesList.filter(role => ROLES_HAS_JOURNAL.indexOf(role.slug) !== -1).map(role => role.id);
    }

    /**
     * Is disabled submit handler
     *
     * @returns {boolean}
     */
    isDisabledSubmit() {
        const { rolesList, userRolesList } = this.props;
        const { role, journal } = this.state;

        if (role === null) {
            return true;
        }

        const roleSlug = rolesList.find(roleItem => roleItem.id === role).slug;
        if (journal !== null || ROLES_HAS_JOURNAL.indexOf(roleSlug) === -1) {
            return false;
        }

        return (
            roleSlug !== ROLE_REVIEWER ||
            userRolesList.some(roleItem => roleItem.role_id === role && roleItem.journal_id === null)
        );
    }

    /**
     * Set role
     *
     * @param role
     */
    setRole = role => {
        const { loadJournalsAutocomplete } = this.props;
        this.setState({ role, journal: null }, () => loadJournalsAutocomplete(this.getJournalsFilter()));
    };

    /**
     * Set journal
     *
     * @param journal
     */
    setJournal = journal => {
        this.setState({ journal });
    };

    /**
     * Open lightbox handler
     */
    openLightbox = () => {
        this.setState({ isOpen: true });
    };

    /**
     * Submit lightbox handler
     */
    handleSubmit = () => {
        const {
            storeUserRole,
            match: {
                params: { id },
            },
        } = this.props;

        const { role, journal } = this.state;

        storeUserRole({
            user_id: id,
            role_id: role,
            journal_id: journal,
        }).then(() => this.handleClose());
    };

    /**
     * Close lightbox handler
     */
    handleClose = () => {
        this.setState({ isOpen: false, role: null, journal: null });
    };

    /**
     * Render
     *
     * @returns {*}
     */
    render() {
        const { role, journal, isOpen } = this.state;
        const hasJournal = this.getHasJournalRoles().indexOf(role) !== -1;

        return (
            <div className='add-role-dialog-btn-wrapper'>
                <Button color="primary" onClick={this.openLightbox} right>
                    <FormattedMessage id="button.user.role.create" />
                </Button>

                <Lightbox
                    handleClose={this.handleClose}
                    isOpen={isOpen}
                    title="title.users.roles.add"
                    actionsClass='user-roles-lightbox-btns-wrapper'
                    actions={
                        <Fragment>
                            <Button onClick={this.handleClose} color="danger">
                                <FormattedMessage id="button.cancel" />
                            </Button>
                            <Button onClick={this.handleSubmit} color="success" disabled={this.isDisabledSubmit()}>
                                <FormattedMessage id="button.submit" />
                            </Button>
                        </Fragment>
                    }
                >
                    <GridContainer>
                        <ItemGrid md={5}>
                            <CustomSelect
                                options={this.getRolesList()}
                                value={role}
                                onChange={this.setRole}
                                placeholder="data_table.filter.role_id"
                            />
                        </ItemGrid>
                        <ItemGrid md={7}>
                            {hasJournal && (
                                <JournalAutocomplete
                                    filter={this.getJournalsFilter()}
                                    onChange={this.setJournal}
                                    value={journal}
                                    isClearable
                                />
                            )}
                        </ItemGrid>
                    </GridContainer>
                </Lightbox>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/UserEdit/containers/UserAddRole.jsx